import React, { FC } from 'react'
import { styled } from '@moonpig/launchpad-utils'
import { spacingPx } from '@moonpig/launchpad-theme'
import {
  CarouselRoot,
  CarouselControls,
  CarouselState,
  CarouselPreviousButton,
  CarouselNextButton,
  UnstyledCarouselScrollArea,
  Flex,
  Box,
} from '@moonpig/launchpad-components'
import { system as s } from '@moonpig/launchpad-system'
import { useFindLocaleText } from '../../text-localisation'
import { useSearchStore } from '../../store/SearchStore'
import { createCarouselFilterItems } from './createCarouselFilterItems'
import { useNbaFilters } from '../../utils/nbaFilters'
import { getSelectedIntegerFilters } from '../../store/helpers'

const StyledFlex = styled(Flex)`
  ${s({
    width: { xs: '100vw', md: '100%' },
    maxWidth: '1200px',
    marginX: 'auto',
    flexDirection: 'column',
    pb: { xs: 3, md: 4 },
    mb: 0,
    pr: { md: 6, xl: 0 },
    pl: { xs: 6, xl: 0 },
  })}
`

const StyledCarouselRoot = styled(CarouselRoot)`
  ${s({
    px: 0,
  })}
`

const StyledCarouselScrollArea = styled(UnstyledCarouselScrollArea)`
  gap: ${spacingPx(4)};
  & ul {
    overflow-y: hidden;
  }
`

export const FiltersCarousel: FC<{ withNbaFilters?: boolean }> = ({
  withNbaFilters = true,
}) => {
  const localiseText = useFindLocaleText()

  const filtersfromStore = useSearchStore(store => store.filters) || []
  const filters = useNbaFilters(filtersfromStore)
  const resultsLoading = useSearchStore(store => store.loading)
  const selectedFilters = useSearchStore(store => store.selectedFilters)
  const optimisticRender = useSearchStore(store => store.optimisticRender)
  const integerFilters = useSearchStore(store => store.integerFilters)

  const appliedIntegerFilters = getSelectedIntegerFilters({
    filters: filtersfromStore,
    integerFilters,
  })

  const carouselItems = createCarouselFilterItems({
    filters,
    resultsLoading,
    selectedFilters: [...selectedFilters, ...appliedIntegerFilters],
    optimisticRender,
    localiseText,
    withNbaFilters,
  })

  return (
    <StyledFlex data-testid="filters-carousel">
      {carouselItems.length > 0 ? (
        <CarouselState>
          <StyledCarouselRoot aria-label={localiseText('find.popular_filters')}>
            <Box display={{ xs: 'none', md: 'block' }}>
              <CarouselControls>
                <CarouselPreviousButton />
                <CarouselNextButton />
              </CarouselControls>
            </Box>
            <StyledCarouselScrollArea>{carouselItems}</StyledCarouselScrollArea>
          </StyledCarouselRoot>
        </CarouselState>
      ) : /* istanbul ignore next */ null}
    </StyledFlex>
  )
}
